import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { AppLockEffects } from './category-app-lock.effects';
import { appLockReducer } from './category-app-lock.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('app-lock', appLockReducer),
    EffectsModule.forFeature([AppLockEffects]),
  ],
  providers: [],
})
export class CategoryAppLockStoreModule {}
